<template>
  <div class="home">
    <div class="content-wrapper" v-loading="savingPdf">
      <div class="content-real">
        <basic-form
          title="Label Info"
          :form-params="LabelInfoDict"
          :mode="FormModes.SPARSE"
          :value-change-cb="labelConfigChange"
        >
          <template slot="actions">
            <el-button
              size="mini"
              type="primary"
              :disabled="savePdfDisabled"
              plain
              @click="savePdf"
            >
              Save Pdf
            </el-button>
          </template>
        </basic-form>
        <div class="preview">
          <div
            class="two-label"
            v-for="(_, index) in Array.from(
              'x'.repeat(Math.round(generatedLabels.length / 2))
            )"
            :key="'label-row-' + index"
          >
            <div
              class="label print-label"
              v-for="(label, innerIndex) in generatedLabels.slice(
                index * 2,
                (index + 1) * 2
              )"
              :key="'label-item-' + index * 2 + innerIndex"
              :id="'label-print' + (index * 2 + innerIndex)"
            >
              <div class="label-title">ANKER_RII</div>
              <div class="one-row sku">
                <span class="label">SKU</span>
                <span class="content">{{ label.sku }}</span>
              </div>
              <div class="one-row boxes">
                <span class="label">BOXES</span>
                <span class="content">{{ label.boxes }}</span>
              </div>
              <div class="one-row plid">
                <span class="label">PLID</span>
                <div class="content">
                  <svg :id="label.pallet_id"></svg>
                </div>
              </div>
              <div class="one-row nos">
                <span class="label">理货单号</span>
                <div class="content">{{ label.order_no }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JsBarcode from 'jsbarcode'
import { LabelInfoDict, FormModes } from '@/core/models/labels'
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'HomePage',
  components: {
    BasicForm
  },
  data() {
    return {
      LabelInfoDict,
      FormModes,
      generatedLabels: [],
      savingPdf: false,
      labelConfigs: {
        sku: 'CD123456789',
        boxes: 12,
        pallet_id: 'TPR0418',
        pallet_count: 1,
        order_no: 'DLT20220303000130BS'
      }
    }
  },
  watch: {
    labelConfigs: {
      handler: function () {
        this.$set(this, 'generatedLabels', this.generateBarcodes())
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    savePdfDisabled() {
      return this.generatedLabels.length === 0
    }
  },
  methods: {
    labelConfigChange(key, value) {
      this.$set(this.labelConfigs, key, value)
    },
    generateBarcodes() {
      // validate
      const labels = []
      const basicInfo = {
        ...this.labelConfigs
      }
      delete basicInfo.pallet_count
      for (let i = 0; i < this.labelConfigs.pallet_count; i++) {
        const item = {
          sku: basicInfo.sku,
          boxes: basicInfo.boxes,
          pallet_id:
            this.labelConfigs.pallet_id + String(i + 1).padStart(3, '0'),
          order_no: basicInfo.order_no
        }
        setTimeout(
          (function () {
            const palletId = item.pallet_id
            return () => {
              JsBarcode('#' + palletId, palletId, {
                height: 60
              })
            }
          })(),
          200
        )
        labels.push(item)
      }
      return labels
    },
    savePdf() {
      this.savingPdf = true
      // this.ExportSavePdf('print-label', 'label')
      this.ExportSavePdf('labels', 111).then(() => {
        this.savingPdf = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
$header-height: 64px;
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content-wrapper {
    width: 100%;
    margin-bottom: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    .content-real {
      .preview {
        min-height: 200px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .two-label {
          display: flex;
          flex-direction: row;
          gap: 20px;
          padding: 5px 0;
          .label {
            .label-title {
              font-size: 18px;
            }
            .one-row {
              width: 510px;
              border: solid 1px black;
              border-bottom: none;
              display: flex;
              align-items: center;
              justify-content: center;
              .label {
                width: 150px;
                font-weight: bolder;
                border-right: solid 1px black;
                display: flex;
                text-align: center;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
              }
              .content {
                font-weight: bold;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex-grow: 1;
              }
              &:last-child {
                border-bottom: solid 1px black;
              }
            }
          }
        }
      }
    }
  }
}
.sku {
  font-size: 46px;
  .label {
    padding-top: 15px;
    line-height: 72px;
    height: 72px;
  }
  .content {
    padding-top: 15px;
  }
}
.boxes {
  /* font-size: 24px; */
  height: 42px;
}
.plid {
  height: 110px;
  /* font-size: 24px; */
  .conte {
    svg {
      height: 100px !important;
    }
  }
}
.nos {
  height: 46px;
}
</style>
